import client from "@https/api";
import type {
    IWishlistCreateRequest,
    IWishlistCreateResponse,
    IWishlistDetailResponse,
    IWishlistEditRequest,
    IWishlistRemoveProductRequest,
    IUpdateProductWishlistsRequest,
    IWishlistsProductsResponse,
    IWishlistCheckResponse,
    IWishlistItem,
} from "@types";
import gate from "../gate";

const wishlistApi = {
    create: (data: IWishlistCreateRequest) =>
        gate.post<IWishlistCreateResponse, IWishlistCreateRequest, never>({
            client,
            url: "user/wishlist",
            data,
        }),

    delete: (id: string | number) =>
        gate.post<any, never, never>({
            client,
            url: `user/wishlist/${id}/delete`,
        }),

    edit: (id: string | number, data: IWishlistEditRequest) =>
        gate.post<any, IWishlistEditRequest, never>({
            client,
            url: `user/wishlist/${id}/edit`,
            data,
        }),

    removeProduct: (id: string | number, data: IWishlistRemoveProductRequest) =>
        gate.post<any, IWishlistRemoveProductRequest, never>({
            client,
            url: `user/wishlist/${id}/removeProduct`,
            data,
        }),

    updateProductWishlists: (data: IUpdateProductWishlistsRequest) =>
        gate.post<any, IUpdateProductWishlistsRequest, never>({
            client,
            url: "user/wishlist/updateProductWishlists",
            data,
        }),

    list: (productId?: number) =>
        gate.get<IWishlistItem[], never, { product_id?: number }>({
            client,
            url: "user/wishlist",
            params: productId ? { product_id: productId } : undefined,
        }),

    getDetail: (id: string | number, cursor:string) =>
        gate.get<IWishlistDetailResponse, never, {paginate:true}>({
            client,
            url: `user/wishlist/${id}/products/${cursor}`,
            params: { paginate: true },
        }),

    getAllProducts: (cursor: string) =>
        gate.get<IWishlistsProductsResponse, never, {paginate:true}>({
            client,
            url: `user/wishlist/products/${cursor}`,
            params: { paginate: true },
        }),

    check: (id: string | number) =>
        gate.get<IWishlistCheckResponse, never, never>({
            client,
            url: `user/wishlist/${id}/check`,
        }),

    addToDefaultWishlist: (product_ids: Array<string | number>) =>
        gate.post<IWishlistCheckResponse, { product_ids: Array<string | number> }, never>({
            client,
            url: `user/wishlist/addToDefaultWishlist`,
            data: { product_ids },
        }),
};

export default wishlistApi; 